import { render } from "./OperationsCenter.vue?vue&type=template&id=3caddec1&scoped=true"
import script from "./OperationsCenter.vue?vue&type=script&lang=js"
export * from "./OperationsCenter.vue?vue&type=script&lang=js"

import "./OperationsCenter.vue?vue&type=style&index=0&id=3caddec1&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caddec1"]])

export default __exports__